/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { PlatformApiResultOfAanmeldValidationResult } from '../models/platform-api-result-of-aanmeld-validation-result';
import { PlatformApiResultOfBoolean } from '../models/platform-api-result-of-boolean';
import { PlatformApiResultOfDataSourceResultDtoOfUserAccountDto } from '../models/platform-api-result-of-data-source-result-dto-of-user-account-dto';
import { PlatformApiResultOfIEnumerableOfRegistrationKeyDto } from '../models/platform-api-result-of-i-enumerable-of-registration-key-dto';
import { PlatformApiResultOfRegistrationConfigDto } from '../models/platform-api-result-of-registration-config-dto';
import { PlatformApiResultOfRegistrationKeyDto } from '../models/platform-api-result-of-registration-key-dto';
import { PlatformApiResultOfString } from '../models/platform-api-result-of-string';
import { PlatformApiResultOfUserAccountDto } from '../models/platform-api-result-of-user-account-dto';
import { PlatformApiResultOfUserInfoDto } from '../models/platform-api-result-of-user-info-dto';
import { getUseraccountsRegistrationConfig } from '../fn/user-account/get-useraccounts-registration-config';
import { GetUseraccountsRegistrationConfig$Params } from '../fn/user-account/get-useraccounts-registration-config';
import { getUseraccountsRegistrationKeys } from '../fn/user-account/get-useraccounts-registration-keys';
import { GetUseraccountsRegistrationKeys$Params } from '../fn/user-account/get-useraccounts-registration-keys';
import { headUseraccountsRegistrationConfig } from '../fn/user-account/head-useraccounts-registration-config';
import { HeadUseraccountsRegistrationConfig$Params } from '../fn/user-account/head-useraccounts-registration-config';
import { postUseraccountsActionAdminTriggerPasswordReset } from '../fn/user-account/post-useraccounts-action-admin-trigger-password-reset';
import { PostUseraccountsActionAdminTriggerPasswordReset$Params } from '../fn/user-account/post-useraccounts-action-admin-trigger-password-reset';
import { postUseraccountsActionAdminVerify } from '../fn/user-account/post-useraccounts-action-admin-verify';
import { PostUseraccountsActionAdminVerify$Params } from '../fn/user-account/post-useraccounts-action-admin-verify';
import { postUseraccountsActionAuthenticate } from '../fn/user-account/post-useraccounts-action-authenticate';
import { PostUseraccountsActionAuthenticate$Params } from '../fn/user-account/post-useraccounts-action-authenticate';
import { postUseraccountsActionCreateRegistrationKey } from '../fn/user-account/post-useraccounts-action-create-registration-key';
import { PostUseraccountsActionCreateRegistrationKey$Params } from '../fn/user-account/post-useraccounts-action-create-registration-key';
import { postUseraccountsActionDeactivate } from '../fn/user-account/post-useraccounts-action-deactivate';
import { PostUseraccountsActionDeactivate$Params } from '../fn/user-account/post-useraccounts-action-deactivate';
import { postUseraccountsActionForceLogout } from '../fn/user-account/post-useraccounts-action-force-logout';
import { PostUseraccountsActionForceLogout$Params } from '../fn/user-account/post-useraccounts-action-force-logout';
import { postUseraccountsActionForgotpassword } from '../fn/user-account/post-useraccounts-action-forgotpassword';
import { PostUseraccountsActionForgotpassword$Params } from '../fn/user-account/post-useraccounts-action-forgotpassword';
import { postUseraccountsActionReactivate } from '../fn/user-account/post-useraccounts-action-reactivate';
import { PostUseraccountsActionReactivate$Params } from '../fn/user-account/post-useraccounts-action-reactivate';
import { postUseraccountsActionRefreshToken } from '../fn/user-account/post-useraccounts-action-refresh-token';
import { PostUseraccountsActionRefreshToken$Params } from '../fn/user-account/post-useraccounts-action-refresh-token';
import { postUseraccountsActionRegister } from '../fn/user-account/post-useraccounts-action-register';
import { PostUseraccountsActionRegister$Params } from '../fn/user-account/post-useraccounts-action-register';
import { postUseraccountsActionResendVerification } from '../fn/user-account/post-useraccounts-action-resend-verification';
import { PostUseraccountsActionResendVerification$Params } from '../fn/user-account/post-useraccounts-action-resend-verification';
import { postUseraccountsActionResetpassword } from '../fn/user-account/post-useraccounts-action-resetpassword';
import { PostUseraccountsActionResetpassword$Params } from '../fn/user-account/post-useraccounts-action-resetpassword';
import { postUseraccountsActionRevokeRegistrationKey } from '../fn/user-account/post-useraccounts-action-revoke-registration-key';
import { PostUseraccountsActionRevokeRegistrationKey$Params } from '../fn/user-account/post-useraccounts-action-revoke-registration-key';
import { postUseraccountsActionRevokeToken } from '../fn/user-account/post-useraccounts-action-revoke-token';
import { PostUseraccountsActionRevokeToken$Params } from '../fn/user-account/post-useraccounts-action-revoke-token';
import { postUseraccountsActionSetRegistrationEnabled } from '../fn/user-account/post-useraccounts-action-set-registration-enabled';
import { PostUseraccountsActionSetRegistrationEnabled$Params } from '../fn/user-account/post-useraccounts-action-set-registration-enabled';
import { postUseraccountsActionUpdate } from '../fn/user-account/post-useraccounts-action-update';
import { PostUseraccountsActionUpdate$Params } from '../fn/user-account/post-useraccounts-action-update';
import { postUseraccountsActionValidateemailandpassword } from '../fn/user-account/post-useraccounts-action-validateemailandpassword';
import { PostUseraccountsActionValidateemailandpassword$Params } from '../fn/user-account/post-useraccounts-action-validateemailandpassword';
import { postUseraccountsActionVerify } from '../fn/user-account/post-useraccounts-action-verify';
import { PostUseraccountsActionVerify$Params } from '../fn/user-account/post-useraccounts-action-verify';
import { postUseraccountsQueryDatasource } from '../fn/user-account/post-useraccounts-query-datasource';
import { PostUseraccountsQueryDatasource$Params } from '../fn/user-account/post-useraccounts-query-datasource';

@Injectable({ providedIn: 'root' })
export class PlatformUserAccountService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getUseraccountsRegistrationConfig()` */
  static readonly GetUseraccountsRegistrationConfigPath = '/api/useraccounts/registration-config';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUseraccountsRegistrationConfig()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUseraccountsRegistrationConfig$Response(params?: GetUseraccountsRegistrationConfig$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfRegistrationConfigDto>> {
    return getUseraccountsRegistrationConfig(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getUseraccountsRegistrationConfig$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUseraccountsRegistrationConfig(params?: GetUseraccountsRegistrationConfig$Params, context?: HttpContext): Observable<PlatformApiResultOfRegistrationConfigDto> {
    return this.getUseraccountsRegistrationConfig$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlatformApiResultOfRegistrationConfigDto>): PlatformApiResultOfRegistrationConfigDto => r.body)
    );
  }

  /** Path part for operation `headUseraccountsRegistrationConfig()` */
  static readonly HeadUseraccountsRegistrationConfigPath = '/api/useraccounts/registration-config';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `headUseraccountsRegistrationConfig()` instead.
   *
   * This method doesn't expect any request body.
   */
  headUseraccountsRegistrationConfig$Response(params?: HeadUseraccountsRegistrationConfig$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfRegistrationConfigDto>> {
    return headUseraccountsRegistrationConfig(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `headUseraccountsRegistrationConfig$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  headUseraccountsRegistrationConfig(params?: HeadUseraccountsRegistrationConfig$Params, context?: HttpContext): Observable<PlatformApiResultOfRegistrationConfigDto> {
    return this.headUseraccountsRegistrationConfig$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlatformApiResultOfRegistrationConfigDto>): PlatformApiResultOfRegistrationConfigDto => r.body)
    );
  }

  /** Path part for operation `postUseraccountsActionSetRegistrationEnabled()` */
  static readonly PostUseraccountsActionSetRegistrationEnabledPath = '/api/useraccounts/action/set-registration-enabled';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postUseraccountsActionSetRegistrationEnabled()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postUseraccountsActionSetRegistrationEnabled$Response(params: PostUseraccountsActionSetRegistrationEnabled$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfRegistrationConfigDto>> {
    return postUseraccountsActionSetRegistrationEnabled(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postUseraccountsActionSetRegistrationEnabled$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postUseraccountsActionSetRegistrationEnabled(params: PostUseraccountsActionSetRegistrationEnabled$Params, context?: HttpContext): Observable<PlatformApiResultOfRegistrationConfigDto> {
    return this.postUseraccountsActionSetRegistrationEnabled$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlatformApiResultOfRegistrationConfigDto>): PlatformApiResultOfRegistrationConfigDto => r.body)
    );
  }

  /** Path part for operation `getUseraccountsRegistrationKeys()` */
  static readonly GetUseraccountsRegistrationKeysPath = '/api/useraccounts/registration-keys';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUseraccountsRegistrationKeys()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUseraccountsRegistrationKeys$Response(params?: GetUseraccountsRegistrationKeys$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfIEnumerableOfRegistrationKeyDto>> {
    return getUseraccountsRegistrationKeys(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getUseraccountsRegistrationKeys$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUseraccountsRegistrationKeys(params?: GetUseraccountsRegistrationKeys$Params, context?: HttpContext): Observable<PlatformApiResultOfIEnumerableOfRegistrationKeyDto> {
    return this.getUseraccountsRegistrationKeys$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlatformApiResultOfIEnumerableOfRegistrationKeyDto>): PlatformApiResultOfIEnumerableOfRegistrationKeyDto => r.body)
    );
  }

  /** Path part for operation `postUseraccountsActionCreateRegistrationKey()` */
  static readonly PostUseraccountsActionCreateRegistrationKeyPath = '/api/useraccounts/action/create-registration-key';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postUseraccountsActionCreateRegistrationKey()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postUseraccountsActionCreateRegistrationKey$Response(params: PostUseraccountsActionCreateRegistrationKey$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfRegistrationKeyDto>> {
    return postUseraccountsActionCreateRegistrationKey(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postUseraccountsActionCreateRegistrationKey$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postUseraccountsActionCreateRegistrationKey(params: PostUseraccountsActionCreateRegistrationKey$Params, context?: HttpContext): Observable<PlatformApiResultOfRegistrationKeyDto> {
    return this.postUseraccountsActionCreateRegistrationKey$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlatformApiResultOfRegistrationKeyDto>): PlatformApiResultOfRegistrationKeyDto => r.body)
    );
  }

  /** Path part for operation `postUseraccountsActionRevokeRegistrationKey()` */
  static readonly PostUseraccountsActionRevokeRegistrationKeyPath = '/api/useraccounts/action/revoke-registration-key';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postUseraccountsActionRevokeRegistrationKey()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postUseraccountsActionRevokeRegistrationKey$Response(params: PostUseraccountsActionRevokeRegistrationKey$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfRegistrationKeyDto>> {
    return postUseraccountsActionRevokeRegistrationKey(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postUseraccountsActionRevokeRegistrationKey$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postUseraccountsActionRevokeRegistrationKey(params: PostUseraccountsActionRevokeRegistrationKey$Params, context?: HttpContext): Observable<PlatformApiResultOfRegistrationKeyDto> {
    return this.postUseraccountsActionRevokeRegistrationKey$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlatformApiResultOfRegistrationKeyDto>): PlatformApiResultOfRegistrationKeyDto => r.body)
    );
  }

  /** Path part for operation `postUseraccountsActionDeactivate()` */
  static readonly PostUseraccountsActionDeactivatePath = '/api/useraccounts/action/deactivate';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postUseraccountsActionDeactivate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postUseraccountsActionDeactivate$Response(params: PostUseraccountsActionDeactivate$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfUserAccountDto>> {
    return postUseraccountsActionDeactivate(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postUseraccountsActionDeactivate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postUseraccountsActionDeactivate(params: PostUseraccountsActionDeactivate$Params, context?: HttpContext): Observable<PlatformApiResultOfUserAccountDto> {
    return this.postUseraccountsActionDeactivate$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlatformApiResultOfUserAccountDto>): PlatformApiResultOfUserAccountDto => r.body)
    );
  }

  /** Path part for operation `postUseraccountsActionReactivate()` */
  static readonly PostUseraccountsActionReactivatePath = '/api/useraccounts/action/reactivate';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postUseraccountsActionReactivate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postUseraccountsActionReactivate$Response(params: PostUseraccountsActionReactivate$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfUserAccountDto>> {
    return postUseraccountsActionReactivate(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postUseraccountsActionReactivate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postUseraccountsActionReactivate(params: PostUseraccountsActionReactivate$Params, context?: HttpContext): Observable<PlatformApiResultOfUserAccountDto> {
    return this.postUseraccountsActionReactivate$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlatformApiResultOfUserAccountDto>): PlatformApiResultOfUserAccountDto => r.body)
    );
  }

  /** Path part for operation `postUseraccountsActionAdminVerify()` */
  static readonly PostUseraccountsActionAdminVerifyPath = '/api/useraccounts/action/admin-verify';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postUseraccountsActionAdminVerify()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postUseraccountsActionAdminVerify$Response(params: PostUseraccountsActionAdminVerify$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfUserAccountDto>> {
    return postUseraccountsActionAdminVerify(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postUseraccountsActionAdminVerify$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postUseraccountsActionAdminVerify(params: PostUseraccountsActionAdminVerify$Params, context?: HttpContext): Observable<PlatformApiResultOfUserAccountDto> {
    return this.postUseraccountsActionAdminVerify$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlatformApiResultOfUserAccountDto>): PlatformApiResultOfUserAccountDto => r.body)
    );
  }

  /** Path part for operation `postUseraccountsActionAdminTriggerPasswordReset()` */
  static readonly PostUseraccountsActionAdminTriggerPasswordResetPath = '/api/useraccounts/action/admin-trigger-password-reset';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postUseraccountsActionAdminTriggerPasswordReset()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postUseraccountsActionAdminTriggerPasswordReset$Response(params: PostUseraccountsActionAdminTriggerPasswordReset$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfUserAccountDto>> {
    return postUseraccountsActionAdminTriggerPasswordReset(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postUseraccountsActionAdminTriggerPasswordReset$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postUseraccountsActionAdminTriggerPasswordReset(params: PostUseraccountsActionAdminTriggerPasswordReset$Params, context?: HttpContext): Observable<PlatformApiResultOfUserAccountDto> {
    return this.postUseraccountsActionAdminTriggerPasswordReset$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlatformApiResultOfUserAccountDto>): PlatformApiResultOfUserAccountDto => r.body)
    );
  }

  /** Path part for operation `postUseraccountsActionForceLogout()` */
  static readonly PostUseraccountsActionForceLogoutPath = '/api/useraccounts/action/force-logout';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postUseraccountsActionForceLogout()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postUseraccountsActionForceLogout$Response(params: PostUseraccountsActionForceLogout$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfUserAccountDto>> {
    return postUseraccountsActionForceLogout(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postUseraccountsActionForceLogout$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postUseraccountsActionForceLogout(params: PostUseraccountsActionForceLogout$Params, context?: HttpContext): Observable<PlatformApiResultOfUserAccountDto> {
    return this.postUseraccountsActionForceLogout$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlatformApiResultOfUserAccountDto>): PlatformApiResultOfUserAccountDto => r.body)
    );
  }

  /** Path part for operation `postUseraccountsActionRegister()` */
  static readonly PostUseraccountsActionRegisterPath = '/api/useraccounts/action/register';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postUseraccountsActionRegister()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postUseraccountsActionRegister$Response(params: PostUseraccountsActionRegister$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfBoolean>> {
    return postUseraccountsActionRegister(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postUseraccountsActionRegister$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postUseraccountsActionRegister(params: PostUseraccountsActionRegister$Params, context?: HttpContext): Observable<PlatformApiResultOfBoolean> {
    return this.postUseraccountsActionRegister$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlatformApiResultOfBoolean>): PlatformApiResultOfBoolean => r.body)
    );
  }

  /** Path part for operation `postUseraccountsActionVerify()` */
  static readonly PostUseraccountsActionVerifyPath = '/api/useraccounts/action/verify';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postUseraccountsActionVerify()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postUseraccountsActionVerify$Response(params: PostUseraccountsActionVerify$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfBoolean>> {
    return postUseraccountsActionVerify(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postUseraccountsActionVerify$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postUseraccountsActionVerify(params: PostUseraccountsActionVerify$Params, context?: HttpContext): Observable<PlatformApiResultOfBoolean> {
    return this.postUseraccountsActionVerify$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlatformApiResultOfBoolean>): PlatformApiResultOfBoolean => r.body)
    );
  }

  /** Path part for operation `postUseraccountsQueryDatasource()` */
  static readonly PostUseraccountsQueryDatasourcePath = '/api/useraccounts/query/datasource';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postUseraccountsQueryDatasource()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postUseraccountsQueryDatasource$Response(params: PostUseraccountsQueryDatasource$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfDataSourceResultDtoOfUserAccountDto>> {
    return postUseraccountsQueryDatasource(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postUseraccountsQueryDatasource$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postUseraccountsQueryDatasource(params: PostUseraccountsQueryDatasource$Params, context?: HttpContext): Observable<PlatformApiResultOfDataSourceResultDtoOfUserAccountDto> {
    return this.postUseraccountsQueryDatasource$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlatformApiResultOfDataSourceResultDtoOfUserAccountDto>): PlatformApiResultOfDataSourceResultDtoOfUserAccountDto => r.body)
    );
  }

  /** Path part for operation `postUseraccountsActionResendVerification()` */
  static readonly PostUseraccountsActionResendVerificationPath = '/api/useraccounts/action/resend-verification';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postUseraccountsActionResendVerification()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postUseraccountsActionResendVerification$Response(params: PostUseraccountsActionResendVerification$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfBoolean>> {
    return postUseraccountsActionResendVerification(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postUseraccountsActionResendVerification$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postUseraccountsActionResendVerification(params: PostUseraccountsActionResendVerification$Params, context?: HttpContext): Observable<PlatformApiResultOfBoolean> {
    return this.postUseraccountsActionResendVerification$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlatformApiResultOfBoolean>): PlatformApiResultOfBoolean => r.body)
    );
  }

  /** Path part for operation `postUseraccountsActionForgotpassword()` */
  static readonly PostUseraccountsActionForgotpasswordPath = '/api/useraccounts/action/forgotpassword';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postUseraccountsActionForgotpassword()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postUseraccountsActionForgotpassword$Response(params: PostUseraccountsActionForgotpassword$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfString>> {
    return postUseraccountsActionForgotpassword(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postUseraccountsActionForgotpassword$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postUseraccountsActionForgotpassword(params: PostUseraccountsActionForgotpassword$Params, context?: HttpContext): Observable<PlatformApiResultOfString> {
    return this.postUseraccountsActionForgotpassword$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlatformApiResultOfString>): PlatformApiResultOfString => r.body)
    );
  }

  /** Path part for operation `postUseraccountsActionResetpassword()` */
  static readonly PostUseraccountsActionResetpasswordPath = '/api/useraccounts/action/resetpassword';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postUseraccountsActionResetpassword()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postUseraccountsActionResetpassword$Response(params: PostUseraccountsActionResetpassword$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfBoolean>> {
    return postUseraccountsActionResetpassword(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postUseraccountsActionResetpassword$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postUseraccountsActionResetpassword(params: PostUseraccountsActionResetpassword$Params, context?: HttpContext): Observable<PlatformApiResultOfBoolean> {
    return this.postUseraccountsActionResetpassword$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlatformApiResultOfBoolean>): PlatformApiResultOfBoolean => r.body)
    );
  }

  /** Path part for operation `postUseraccountsActionAuthenticate()` */
  static readonly PostUseraccountsActionAuthenticatePath = '/api/useraccounts/action/authenticate';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postUseraccountsActionAuthenticate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postUseraccountsActionAuthenticate$Response(params: PostUseraccountsActionAuthenticate$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfUserInfoDto>> {
    return postUseraccountsActionAuthenticate(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postUseraccountsActionAuthenticate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postUseraccountsActionAuthenticate(params: PostUseraccountsActionAuthenticate$Params, context?: HttpContext): Observable<PlatformApiResultOfUserInfoDto> {
    return this.postUseraccountsActionAuthenticate$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlatformApiResultOfUserInfoDto>): PlatformApiResultOfUserInfoDto => r.body)
    );
  }

  /** Path part for operation `postUseraccountsActionValidateemailandpassword()` */
  static readonly PostUseraccountsActionValidateemailandpasswordPath = '/api/useraccounts/action/validateemailandpassword';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postUseraccountsActionValidateemailandpassword()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postUseraccountsActionValidateemailandpassword$Response(params: PostUseraccountsActionValidateemailandpassword$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfAanmeldValidationResult>> {
    return postUseraccountsActionValidateemailandpassword(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postUseraccountsActionValidateemailandpassword$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postUseraccountsActionValidateemailandpassword(params: PostUseraccountsActionValidateemailandpassword$Params, context?: HttpContext): Observable<PlatformApiResultOfAanmeldValidationResult> {
    return this.postUseraccountsActionValidateemailandpassword$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlatformApiResultOfAanmeldValidationResult>): PlatformApiResultOfAanmeldValidationResult => r.body)
    );
  }

  /** Path part for operation `postUseraccountsActionRefreshToken()` */
  static readonly PostUseraccountsActionRefreshTokenPath = '/api/useraccounts/action/refresh-token';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postUseraccountsActionRefreshToken()` instead.
   *
   * This method doesn't expect any request body.
   */
  postUseraccountsActionRefreshToken$Response(params?: PostUseraccountsActionRefreshToken$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfUserInfoDto>> {
    return postUseraccountsActionRefreshToken(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postUseraccountsActionRefreshToken$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  postUseraccountsActionRefreshToken(params?: PostUseraccountsActionRefreshToken$Params, context?: HttpContext): Observable<PlatformApiResultOfUserInfoDto> {
    return this.postUseraccountsActionRefreshToken$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlatformApiResultOfUserInfoDto>): PlatformApiResultOfUserInfoDto => r.body)
    );
  }

  /** Path part for operation `postUseraccountsActionRevokeToken()` */
  static readonly PostUseraccountsActionRevokeTokenPath = '/api/useraccounts/action/revoke-token';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postUseraccountsActionRevokeToken()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postUseraccountsActionRevokeToken$Response(params: PostUseraccountsActionRevokeToken$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfString>> {
    return postUseraccountsActionRevokeToken(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postUseraccountsActionRevokeToken$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postUseraccountsActionRevokeToken(params: PostUseraccountsActionRevokeToken$Params, context?: HttpContext): Observable<PlatformApiResultOfString> {
    return this.postUseraccountsActionRevokeToken$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlatformApiResultOfString>): PlatformApiResultOfString => r.body)
    );
  }

  /** Path part for operation `postUseraccountsActionUpdate()` */
  static readonly PostUseraccountsActionUpdatePath = '/api/useraccounts/action/update';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postUseraccountsActionUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postUseraccountsActionUpdate$Response(params: PostUseraccountsActionUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfUserAccountDto>> {
    return postUseraccountsActionUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postUseraccountsActionUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postUseraccountsActionUpdate(params: PostUseraccountsActionUpdate$Params, context?: HttpContext): Observable<PlatformApiResultOfUserAccountDto> {
    return this.postUseraccountsActionUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlatformApiResultOfUserAccountDto>): PlatformApiResultOfUserAccountDto => r.body)
    );
  }

}
